// latest: hansong 2017-2-21 4:25 PM
import { Model } from 'common'
Model.define('model.ag_reject', {
  proxy: {
    get: '/cpu-supplymgr/notice/oneNotice',
    post: '/cpu-supplymgr/rejectCommon/saveRejectCommon'
  },
  meta: {
    id: '',
    content: '',
    creatorId: '', // 类型
    creatorName: '',
    typeId: '',
    typeName: '',
    ts: ''
  }
})

export default Model.create('model.ag_reject')



// WEBPACK FOOTER //
// ./src/data/model/ag_reject/index.js